import { PersonPickerWidget } from "./PersonPicker/PersonPickerWidget";
import { EvalutaionCheckWidget } from "./EvaluationCheck/EvalutaionCheckWidget";
import { EvaluationCounterWidget } from "./EvaluationCounter/EvaluationCounterWidget";

export default {

    personPicker: PersonPickerWidget,
    evaluationCheck: EvalutaionCheckWidget,
    evaluationCounter: EvaluationCounterWidget

}